import React from 'react';
import styled from '@emotion/styled';
import logo from '../assets/icons/logo.png';

interface CategoryProfileProps {
  name: string;
  tag: string;
}

export const CategoryProfile: React.FC<CategoryProfileProps> = ({ name, tag }) => {
  return (
    <Container>
      <LogoContainer>
        <Logo src={logo} alt={name} />
      </LogoContainer>
      <CategoryName>{name}</CategoryName>
      <CategoryTag>{tag}</CategoryTag>
    </Container>
  );
};

const Container = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
`;

const LogoContainer = styled.div`
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const CategoryName = styled.h2`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
  color:rgb(38, 71, 142);
  text-align: center;
`;

const CategoryTag = styled.p`
  font-size: 15px;
  color: #666;
  text-align: center;
`;